import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../../api';
import { MixerOverRateItem, MixerOverRateItemCreate } from '../types';

const MixerOverRate = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getMixerOverRate: builder.query<MixerOverRateItem, PayloadRequest>({
      query: () => ({
        url: '/v1/mixerOverRate',
      }),
    }),
    getMixerOverRateDetail: builder.query<MixerOverRateItemCreate, PayloadRequest>({
      query: (data) => ({
        url: `/v1/mixerOverRate/${data.id}`,
      }),
    }),
    changeMixerOverRate: builder.mutation<void, MixerOverRateItemCreate>({
      query: (data) => ({
        url: `/v1/mixerOverRate/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    createMixerOverRate: builder.mutation<void, MixerOverRateItemCreate>({
      query: (data) => ({
        url: '/v1/mixerOverRate',
        method: 'POST',
        body: data,
      }),
    }),
    deleteMixerOverRate: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/mixerOverRate/${data.id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useChangeMixerOverRateMutation,
  useCreateMixerOverRateMutation,
  useGetMixerOverRateDetailQuery,
  useGetMixerOverRateQuery,
  useLazyGetMixerOverRateDetailQuery,
  useLazyGetMixerOverRateQuery,
  useDeleteMixerOverRateMutation,
} = MixerOverRate;
